import React from 'react';
import { SUPPORT_EMAIL } from '../../util/config';
import Modal from '../Modal/Modal';
import Card from '../Card/Card';
import ButtonGroup from '../ButtonGroup/ButtonGroup';
import Button from '../Button/Button';

// no hook for componentDidCatch yet (05/09/2019) so need to use a class component
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error) {
    console.log(error);
    this.setState({ hasError: true });
  }

  render() {
    const refreshApp = () => {
      window.location = '';
    };
    const handleContact = () => {
      window.location.href = `mailto:${SUPPORT_EMAIL}`;
    };
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div>
          <Modal show>
            <Card title="Something went wrong">
              <p>
                Apologies, tap &quot;Reload&quot; to resume from the last saved
                data. If this problem persists please contact support.
              </p>
              <ButtonGroup>
                <Button label="Reload" onClick={refreshApp} />
              </ButtonGroup>
            </Card>
          </Modal>
        </div>
      );
    }
    return children;
  }
}
